pnk-navigation {
    /* Component styles go here */
}
